import { BASE_URL } from "../config/config";
import axiosInstance from "./axiosInstance";


// -------------------------
//  LOGIN
// -------------------------
export const loginUser = async (credentials) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/login`, credentials);
    return response;
  } catch (error) {
    console.error("Login error:", error.response?.data || error.message);
    throw new Error(
      error?.response?.data?.message || "Login failed. Please try again."
    );
  }
};

// -------------------------
//  REGISTER
// -------------------------
export const registerUser = async (formData) => {
  return await axiosInstance.post(`${BASE_URL}/signUp`, formData);
};

// -------------------------
//  SEND OTP
// -------------------------
export const sendOTP = async ({ email }) => {
  return await axiosInstance.post(`${BASE_URL}/sendOtp`, { email });
};

// -------------------------
//  RESET PASSWORD
// -------------------------
export const resetPassword = async (data) => {
  return await axiosInstance.post(`${BASE_URL}/forgetPassword`, data);
};

// -------------------------
//  UPDATE USER INFO
// -------------------------
export const updateUser = async (data, token) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/updateUser`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update user error:", error.response?.data || error.message);
    throw new Error(
      error?.response?.data?.message || "Failed to update user"
    );
  }
};

// -------------------------
//  GET USER PROFILE
// -------------------------
export const getUserProfile = async (token) => {
  const response = await axiosInstance.get(`${BASE_URL}/auth/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


// -------------------------
// SUBMIT CONTACT FORM 
// -------------------------
export const submitContactForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/contact`, formData);
    return response.data;
  } catch (error) {
    console.error("Contact form error:", error.response?.data || error.message);
    throw new Error(
      error?.response?.data?.message || "Failed to send contact form."
    );
  }
};




export const getCompanyDetails = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/company`);
  return res.data?.data;
};
